import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { agencySettingsStore } from 'services/agency-settings';
import { AgencySettingKey } from 'services/agency-settings/types';
import {
  AuthFooterContainer,
  AuthFooterDivider,
  AuthFooterLink,
  AuthFooterLinksContainer,
  AuthFooterText,
} from './styles';
import { FOOTER__TERMS_AND_CONDITIONS, FOOTER__PRIVACY_POLICY } from '../../translations/constants';

const AuthFooter = (): JSX.Element => {
  const [t] = useTranslation();
  const [agencySettings, setAgencySettings] = useState(agencySettingsStore.get());

  useEffect(() => {
    const loadSettings = async () => {
      const settings = await agencySettingsStore.getOrLoad();
      setAgencySettings(settings);
    };

    if (!agencySettings) {
      loadSettings();
    }
  }, [agencySettings]);

  const termsAndConditionsLink = agencySettings?.[AgencySettingKey.TermsAndConditionsLink] ?? '';
  const privacyPolicyLink = agencySettings?.[AgencySettingKey.PrivacyPolicyLink] ?? '';
  const webSiteUrl = agencySettings?.[AgencySettingKey.WebSiteUrl] ?? '';

  return (
    <AuthFooterContainer>
      <AuthFooterDivider />
      <AuthFooterLinksContainer>
        <AuthFooterLink href={termsAndConditionsLink} target="_blank">
          <AuthFooterText>{t(FOOTER__TERMS_AND_CONDITIONS)}</AuthFooterText>
        </AuthFooterLink>

        <AuthFooterLink href={privacyPolicyLink} target="_blank">
          <AuthFooterText centerText>{t(FOOTER__PRIVACY_POLICY)}</AuthFooterText>
        </AuthFooterLink>

        <AuthFooterLink href={webSiteUrl} target="_blank">
          <AuthFooterText>
            <strong>{webSiteUrl?.replace('https://', '')}</strong>
          </AuthFooterText>
        </AuthFooterLink>
      </AuthFooterLinksContainer>
    </AuthFooterContainer>
  );
};

export default AuthFooter;
